// extracted by mini-css-extract-plugin
module.exports = {"entityList":"_3fRhjyOg"};